import { render } from "./ViewUsersModal.vue?vue&type=template&id=27f0fe71&ts=true"
import script from "./ViewUsersModal.vue?vue&type=script&lang=ts"
export * from "./ViewUsersModal.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Develop\\Czone_UI_EIC\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__